import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import UserNode from '@home/components/Orgmap/UserNode.vue'
import DeptNode from '@home/components/Orgmap/DeptNode.vue'
import CompanySelectionModal from '@home/components/Orgmap/CompanySelectionModal.vue'
import UserDetail from '@home/components/Orgmap/UserDetail.vue'
import api from '@home/api'
import { createEventBus, removeEventBus } from '@/util'
import { mapGetters } from 'vuex'
import * as accountTypes from '@account/store/types'
@Component({
    components: { UserNode, DeptNode, CompanySelectionModal, UserDetail },
    computed: {
        ...mapGetters({
            User: accountTypes.USER,
        })
    },
})
export default class OrgmapContainer extends Vue {

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    TreeData: DepartmentEx[] = []
    companies: orgmap.Company[] = []
    currentUser: orgmap.HrUser | null = null
    detailViewMode: boolean = false
    showCompanyModal: boolean = false
    currentCompany: orgmap.Company = Object.create(null)
    searchKeyword: string = ''
    searchData: any[] = []
    searchDepartmentList: UserItemEx[] = []
    searchUserList: UserItemEx[] = []

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    User!: account.User

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    load() {
        api.orgmap.getCompanies().then(async (companies: Array<orgmap.Company>) => {
            this.companies = companies
            var userCompany = this.companies.find((x) => x.comCode == this.User.comCode)
            if (userCompany) await this.handleCompanySelected(userCompany)
            else await this.handleCompanySelected(this.companies[0])
            this.getUserDept()
        })
    }

    /**
     * 그룹사 선택 모달에서 회사를 선택하면 호출됩니다.
     * @param company
     */
    async handleCompanySelected(company: orgmap.Company) {
        const { comCode } = (this.currentCompany = company)
        this.TreeData = await this.getOrgTreeAsync('', comCode)
    }

    /**
     * 헤더 검색바에서 검색어 입력/뒤로가기 시 호출됩니다.
     * @param keyword
     */
    async handleSearchRequest(keyword: string) {
        if (keyword) {
            this.searchData = []
            this.searchUserList = []
            api.orgmap.searchOrg({
                query: keyword,
                size: 100,
            }, this.User.comCode).then((res: any) => {
                if (res.items) {
                    this.searchData = res.items
                    res.items.map((x: any) => {
                        if (x.type === 'D') {
                            this.searchDepartmentList.push(x)
                        } else {
                            this.searchUserList.push(x)
                        }
                    })
                }
            })
        } else {
            this.searchData = []
            this.searchUserList = []
        }
    }

    /**
     * 부서 트리를 로드합니다.
     */
    async getOrgTreeAsync(
        parentDeptCode: string = '',
        compCode: string
    ): Promise<Array<DepartmentEx>> {
        if (!compCode) compCode = this.User.comCode
            const defaultDeptState = {
                expanded: false,
                selected: false,
                children: null,
                users: null,
            }
            const result = await api.orgmap.getOrgTree({
                level: 2,
                comCode: compCode,
                deptCode: '',
                parentDeptCode: parentDeptCode,
            })
            const mapResult = (dept: any) => ({ ...dept, ...defaultDeptState })
            const departments = result.items?.map(mapResult) as Array<DepartmentEx>
            return departments.length ? this.flatToHierarchy(departments) : []
        }

    /**
     * 플랫한 구조의 데이터를 트리 구조로 변환합니다.
     * @param flat 플랫한 구조의 데이터
     * @returns 트리 구조로 정재된 데이터
     */
    flatToHierarchy(flat: Array<DepartmentEx>) {
        var roots: any[] = []
        var all: any = {}
        var flatArr: Array<DepartmentEx> = []
        for (var item of flat) {
            all[item.id] = {
                ...item,
                children: null,
                expanded: false,
                selected: false,
            } as DepartmentEx
            flatArr.push(all[item.id])
        }
        flatArr.forEach(function(item) {
            const parentCode = item.parentDeptCode
            if (!parentCode) {
                roots.push(item)
            } else if (parentCode in all) {
                var p = all[parentCode] as DepartmentEx
                if (!('children' in p) || !p.children) {
                    p.children = []
                }
                p.children.push(item)
            } else {
                roots.push(item)
            }
        })

        return roots
    }

    /**
     * 부서 노드를 토글합니다.
     * 부서를 확장하여 하위 부서 및 사용자 목록을 표시합니다.
     * @param dept 클릭한 부서 객체
     */
    async toggleDepartmentAsync(dept: DepartmentEx) {
        dept.expanded = !dept.expanded
        if (!dept.users) {
            const result = await api.orgmap.getEmployeeList({
                level: 2,
                comCode: dept.comCode,
                deptCode: dept.deptCode,
                parentDeptCode: '',
            } as orgmap.DepartmentOption)
            dept.users = result.items.map((user: any) => ({
                ...user,
                selected: false,
            }))
        }
        if (!dept.children) {
            dept.children = await this.getOrgTreeAsync(dept.deptCode, dept.comCode)
        }
    }

    /**
     * 자신의 부서까지 트리를 확장하고 부서원 목록을 표시합니다.
     */
    getUserDept() {
        api.orgmap.getDeptPath({
            comCode: this.User.comCode,
            deptCode: this.User.deptCode,
        })
        .then(async (res) => {
            var pathArr = res.items[0].path.split('/').slice(1)
            var findDept: DepartmentEx[] = []

            for (var path of pathArr) {
                var dept: DepartmentEx | null = null
                dept = this.TreeData.filter(
                    (x: DepartmentEx) => x.deptCode === path
                )[0]

                if (!dept && findDept.length) {
                    dept = findDept.filter((x: DepartmentEx) => x.deptCode === path)[0]
                }

                if (dept) {
                    await this.toggleDepartmentAsync(dept)
                        findDept = []
                        dept?.children?.map((x) => {
                        findDept.push(x)
                    })
                }
            }
            this.isloading(false)
        })
    }

    detailView(user: orgmap.HrUser) {
        this.$emit('detail', true)
        this.detailViewMode = true
        this.currentUser = user
    }

    detailViewClose() {
        this.$emit('detail', false)
        this.detailViewMode = false
    }
    
    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        createEventBus(window, 'header-search', this.handleSearchRequest)
        this.isloading(true)
        this.load()
    }

    beforeDestroy() {
        removeEventBus(window, 'header-search', this.handleSearchRequest)
    }
}
